import { Component, inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AutoConfig } from '../../models/auto-config';

@Component({
  selector: 'mee-copy-config-confirmation-dialog',
  templateUrl: './copy-config-confirmation-dialog.component.html',
  styleUrls: ['./copy-config-confirmation-dialog.component.scss'],
})
export class CopyConfigConfirmationDialogComponent {
  copyConfigConfirmationData: AutoConfig = inject(MAT_LEGACY_DIALOG_DATA);
}
